<div class="page-container">

  <!-- Page header -->
  <div class="page-header">
    <div class="page-header-left">
      <button class="ph-btn" (click)="goToConsole()">
        <i class="material-icons">arrow_back</i> Back to Console
      </button>
      <div>
        <h4 class="page-title">Call Recordings</h4>
        <div class="page-sub">Recordings captured by this officer line</div>
      </div>
    </div>
    <div class="page-header-right">
      <input class="ph-input" style="width:130px" [(ngModel)]="agentExt" placeholder="Extension…" />
      <button class="ph-btn ph-btn-accent" (click)="loadRecordings()">
        <i class="material-icons">refresh</i> Load
      </button>
      <button class="ph-btn" (click)="downloadCsv()">
        <i class="material-icons">download</i> CSV
      </button>
    </div>
  </div>

  <!-- Filters -->
  <div class="filters-bar">
    <div class="search-box">
      <i class="material-icons search-icon">search</i>
      <input [(ngModel)]="query" placeholder="Search citizen, transcript, file…" class="search-input" />
    </div>
    <select class="filter-select" [(ngModel)]="directionFilter">
      <option value="all">All directions</option>
      <option value="INBOUND">Inbound</option>
      <option value="OUTBOUND">Outbound</option>
    </select>
    <input class="filter-date" type="date" [(ngModel)]="fromDate" title="From date" />
    <input class="filter-date" type="date" [(ngModel)]="toDate"   title="To date" />
    <button class="ph-btn" (click)="clearFilters()">Clear</button>
    <span class="count-badge">{{ filtered.length }} shown</span>
  </div>

  <!-- Table -->
  <div class="table-card">
    <div class="table-wrap">
      <table class="rec-table">
        <thead>
          <tr>
            <th class="sort-th" (click)="sort('recordedAt')">
              Recorded At <i class="material-icons sort-icon">{{ sortIcon('recordedAt') }}</i>
            </th>
            <th class="sort-th" (click)="sort('officerExtension')">
              Officer <i class="material-icons sort-icon">{{ sortIcon('officerExtension') }}</i>
            </th>
            <th class="sort-th" (click)="sort('citizenNumber')">
              Citizen <i class="material-icons sort-icon">{{ sortIcon('citizenNumber') }}</i>
            </th>
            <th class="sort-th" (click)="sort('direction')">
              Direction <i class="material-icons sort-icon">{{ sortIcon('direction') }}</i>
            </th>
            <th class="sort-th" (click)="sort('durationSeconds')">
              Duration <i class="material-icons sort-icon">{{ sortIcon('durationSeconds') }}</i>
            </th>
            <th>Outcome</th>
            <th>Wrap-Up Notes</th>
            <th>Transcript</th>
            <th>Playback</th>
            <th>Download</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="loading">
            <td colspan="10" class="td-center">
              <i class="material-icons spin">refresh</i> Loading recordings…
            </td>
          </tr>
          <tr *ngIf="!loading && !filtered.length">
            <td colspan="10" class="td-center">
              {{ recordings.length ? 'No recordings match the filters' : 'No recordings yet for this extension' }}
            </td>
          </tr>
          <tr *ngFor="let r of filtered">
            <td class="td-sub td-sm">{{ r.recordedAt ? (r.recordedAt | date:'dd/MM/yyyy HH:mm') : '—' }}</td>
            <td><span class="ext-badge">{{ r.officerExtension || '—' }}</span></td>
            <td class="td-sm">{{ r.citizenNumber || '—' }}</td>
            <td>
              <span class="dir-badge"
                [class.dir-in]="r.direction === 'INBOUND'"
                [class.dir-out]="r.direction === 'OUTBOUND'"
                [class.dir-none]="!r.direction">
                {{ r.direction || '—' }}
              </span>
            </td>
            <td class="td-sm">{{ formatDuration(r.durationSeconds) }}</td>
            <td class="outcome-cell">
              <span class="outcome-pill" *ngIf="r.disposition">{{ r.disposition }}</span>
              <span class="outcome-meta" [title]="wrapUpSummary(r) || 'No outcome captured'">
                {{ wrapUpSummary(r) || '-' }}
              </span>
              <span class="callback-due" *ngIf="r.callbackRequired && r.callbackDueAt">
                {{ r.callbackDueAt | date:'dd/MM HH:mm' }}
              </span>
            </td>
            <td class="transcript-cell">
              <span class="transcript-preview" [title]="r.wrapUpNotes || 'No wrap-up notes'">
                {{ r.wrapUpNotes || '—' }}
              </span>
            </td>
            <td class="transcript-cell">
              <span class="transcript-status" [ngClass]="transcriptionStatusClass(r)">
                {{ transcriptionLabel(r) }}
              </span>
              <span class="transcript-preview"
                    [class.transcript-clickable]="r.transcriptText?.trim()"
                    (click)="openTranscript(r)"
                    (keydown.enter)="openTranscript(r)"
                    [title]="transcriptionTitle(r)">
                {{ r.transcriptText || transcriptionLabel(r) }}
              </span>
            </td>
            <td>
              <ng-container *ngIf="r.callRecordingId; else noAudio">
                <audio *ngIf="getAudioBlobUrl(r.callRecordingId) as blobUrl"
                       class="audio-player" controls autoplay
                       [src]="blobUrl"></audio>
                <button *ngIf="!getAudioBlobUrl(r.callRecordingId)" type="button" class="dl-btn"
                        [disabled]="audioLoadingIds.has(r.callRecordingId)"
                        (click)="loadAudio(r.callRecordingId)"
                        [title]="audioLoadingIds.has(r.callRecordingId) ? 'Loading…' : 'Play recording'">
                  <i class="material-icons">{{ audioLoadingIds.has(r.callRecordingId) ? 'hourglass_empty' : 'play_circle' }}</i>
                </button>
              </ng-container>
              <ng-template #noAudio><span class="td-sub">—</span></ng-template>
            </td>
            <td>
              <button *ngIf="r.callRecordingId" type="button" class="dl-btn"
                      [disabled]="downloadingIds.has(r.callRecordingId)"
                      (click)="downloadRecording(r)"
                      [title]="downloadingIds.has(r.callRecordingId) ? 'Downloading...' : 'Download recording'">
                <i class="material-icons">{{ downloadingIds.has(r.callRecordingId) ? 'hourglass_empty' : 'download' }}</i>
              </button>
              <span *ngIf="!r.callRecordingId" class="td-sub">—</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</div>

<!-- Transcript modal -->
<div class="modal-backdrop" *ngIf="transcriptModal" (click)="closeTranscript()" (keydown.escape)="closeTranscript()">
  <div class="modal-card" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">

    <div class="modal-header">
      <div class="modal-title-row">
        <i class="material-icons">closed_caption</i>
        <span class="modal-title">Call Transcript</span>
      </div>
      <div class="modal-meta">
        <span>{{ transcriptModal.recordedAt | date:'dd/MM/yyyy HH:mm' }}</span>
        <span class="modal-meta-sep">·</span>
        <span>Ext {{ transcriptModal.officerExtension }}</span>
        <span class="modal-meta-sep">·</span>
        <span>{{ formatDuration(transcriptModal.durationSeconds) }}</span>
      </div>
      <button class="modal-close" (click)="closeTranscript()">
        <i class="material-icons">close</i>
      </button>
    </div>

    <div class="modal-body">
      <div *ngIf="parsedTranscript.length === 0" class="modal-empty">
        Could not parse transcript segments.
      </div>
      <div *ngFor="let line of parsedTranscript" class="tseg" [class.tseg-agent]="line.isAgent">
        <div class="tseg-header">
          <span class="tseg-speaker">{{ line.speaker }}</span>
          <span class="tseg-time">{{ line.timeLabel }}</span>
        </div>
        <div class="tseg-text">{{ line.text }}</div>
      </div>
    </div>

  </div>
</div>
